/**
 * Application Constants
 * Single source of truth for configuration values
 */

// Map Configuration
export const NL_BOUNDS = {
  latMin: 50.7,
  latMax: 53.6,
  lngMin: 3.3,
  lngMax: 7.2,
} as const;

// Netherlands map bounds for Mapbox
export const NL_MAP_BOUNDS: [number, number, number, number] = [3.3, 50.7, 7.2, 53.6];

// Netherlands center coordinates
export const NL_CENTER: [number, number] = [5.1214, 52.0907];

// Contact Information
export const SUPPORT_EMAIL = "khaylanirecruitmentdashboard@gmail.com" as const;
export const KVK_NUMBER = "98820419" as const;
